import React, { Component, PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { pickBy as _pickBy } from 'lodash';

import SelectList from '../components/Common/SelectList/SelectList';

import {
    setNewBookingPlantType,
    fetchAvailablePlantTypes,
} from '../actions/newBooking';

class PlantTypeSelectorContainer extends Component {
    componentDidMount() {
        const { person } = this.props;
        const allowedPlantTypeIds = person.permissions.canDrivePlantTypeIds;

        // This checks if we need to display an error message about no available plant types or not
        this.props.fetchAvailablePlantTypes(allowedPlantTypeIds);

        // TODO: This is hacky but is required because of the check in CreateStepper.canProgress to prevent next when nothing is present/selected
        // but we also want users to be able to directly progress using the "Any" option, so we must manually set it :-(
        if (allowedPlantTypeIds.length > 0)
            this.props.setNewBookingPlantType(null, `Any`);
    }

    render() {
        const allowedPlantTypeIds = this.props.person.permissions.canDrivePlantTypeIds;
        const allowedPlantTypes = _pickBy(this.props.plantTypes, plant => allowedPlantTypeIds.includes(plant.id));
        const showAnyOption = allowedPlantTypeIds.length > 0;

        return (
            <SelectList
                title="Select Plant Type"
                items={allowedPlantTypes}
                allowAny={showAnyOption}
                selectedItemId={this.props.plantTypeId}
                setSelectedItem={this.props.setNewBookingPlantType}
            />
        );
    }
}

function mapStateToProps(state) {
    const { plantTypeId } = state.newBooking;
    const { plantTypes } = state.entities;
    const { person } = state.environment;

    return {
        plantTypeId,
        plantTypes,
        person,
    };
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        setNewBookingPlantType,
        fetchAvailablePlantTypes,
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(PlantTypeSelectorContainer);



// WEBPACK FOOTER //
// ./scripts/containers/PlantTypeSelectorContainer.jsx